module.exports = __webpack_public_path__ + "img/icon_sx_full.056fedd9.png";